// import React from "react";

// const Loader = () => {
//   const letters = "WELCOME TO UBANKCONNECT".split("");

//   const overlayStyle = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "100vw",
//     height: "100vh",
//     background: "linear-gradient(135deg, #1f1c2c, #928DAB)",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     zIndex: 9999,
//     overflow: "hidden",
//   };

//   const textContainerStyle = {
//     display: "flex",
//     fontSize: "1.2rem",
//     fontWeight: "bold",
//     fontFamily: "'Orbitron', sans-serif",
//     color: "#ffffff",
//     letterSpacing: "0.12em",
//   };

//   const keyframes = `
//     @keyframes floatGlow {
//       0% {
//         transform: translateY(0) scale(1);
//         text-shadow: 0 0 5px #00f2fe, 0 0 10px #00f2fe, 0 0 20px #00f2fe;
//       }
//       50% {
//         transform: translateY(-10px) scale(1.1);
//         text-shadow: 0 0 10px #4facfe, 0 0 20px #4facfe, 0 0 40px #4facfe;
//       }
//       100% {
//         transform: translateY(0) scale(1);
//         text-shadow: 0 0 5px #00f2fe, 0 0 10px #00f2fe, 0 0 20px #00f2fe;
//       }
//     }
//   `;

//   const spanStyle = (index) => ({
//     animation: `floatGlow 1.6s ease-in-out infinite`,
//     animationDelay: `${index * 0.1}s`,
//     display: "inline-block",
//     whiteSpace: "pre", // ensures spaces are preserved
//   });

//   return (
//     <>
//       <style>
//         @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@600&display=swap');
//         {keyframes}
//       </style>
//       <div style={overlayStyle}>
//         <div style={textContainerStyle}>
//           {letters.map((letter, index) => (
//             <span key={index} style={spanStyle(index)}>{letter}</span>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Loader;

// import React from "react";

// const Loader = () => {
//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         width: "100vw",
//         height: "100vh",
//         backgroundColor: "#000",
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 9999,
//       }}
//     >
//       <div
//         className="u-bankconnect"
//         style={{
//           height: "100px",
//           position: "relative",
//           width: "100px",
//         }}
//       >
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           viewBox="0 0 100 100"
//           id="orbit"
//           style={{ maxWidth: "100%" }}
//         >
//           <circle fill="none" stroke="#fff" strokeWidth="5" cx="50" cy="50" r="40" />
//           <circle fill="#1caae8" cx="50" cy="50" r="24" />
//           <text
//             x="50%"
//             y="50%"
//             dominantBaseline="middle"
//             textAnchor="middle"
//             fill="#fff"
//             style={{ fontSize: "300%" }}
//           >
//             u
//           </text>
//         </svg>
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           viewBox="0 0 100 100"
//           id="electron"
//           style={{
//             animation: "logo_kinetics 2.5s linear infinite",
//             position: "absolute",
//             top: "-50%",
//             left: 0,
//             transformOrigin: "bottom center",
//           }}
//         >
//           <circle fill="#1caae8" cx="10" cy="90" r="10" />
//         </svg>
//       </div>

//       <h1
//         style={{
//           fontFamily: `"Helvetica Neue", Helvetica, sans-serif`,
//           fontWeight: "normal",
//           color: "#fff",
//           fontSize: "22px",
//           marginTop: "8px",
//         }}
//       >
//         bankconnect
//       </h1>

//       <style>
//         {`
//           @keyframes logo_kinetics {
//             to {
//               transform: rotate(360deg);
//             }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default Loader;


import React, { useEffect } from "react";
import imageCheck from "./payment_sec.svg"; // Ensure the image path is correct
// import imageCheck from "./check.png"; // Ensure the image path is correct

const Loader = () => {
  useEffect(() => {
    // Prevent body scroll when loader is shown
    document.body.style.overflow = "hidden";

    return () => {
      // Restore scroll when loader is unmounted
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#000",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          height: "200px",
          width: "200px",
          position: "relative",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 100"
          style={{ maxWidth: "100%" }}
        >
          <circle fill="none" stroke="#fff" strokeWidth="5" cx="50" cy="50" r="40" />
          <circle fill="#1caae8" cx="50" cy="50" r="24" />
          <image
              href={imageCheck}
              x="34"
              y="34"
              width="34"
              height="34"
          />
        </svg>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 100"
          style={{
            position: "absolute",
            top: "-50%",
            left: 0,
            transformOrigin: "bottom center",
            animation: "logo_kinetics 2.5s linear infinite",
          }}
        >
          <circle fill="#1caae8" cx="10" cy="90" r="10" />
        </svg>
      </div>

      {/* <h1
        style={{
          fontFamily: `"Helvetica Neue", Helvetica, sans-serif`,
          fontWeight: "normal",
          color: "#fff",
          fontSize: "22px",
          marginTop: "8px",
        }}
      >
        bankconnect
      </h1> */}

      <style>
        {`
          @keyframes logo_kinetics {
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};

export default Loader;

